import { atom } from "recoil";
import { ocPersistAtom } from "oc/states/persist-atom";

export const taxDeclarationThreeChildren = atom({
  key: "taxDeclarationThreeChildren",
  default: {
    dateOfDeclaration: new Date(),
    isModifiedDeclaration: false,
    isEligible: false,
    isEligibleThree: false,
    isEligibleTwo: false,
    permanentlyEntitled: false,
    notApplyFromMonth: "",
    dependents: [],
  },
  effects_UNSTABLE: [ocPersistAtom],
});
